import { gql } from '@apollo/client'

export const EXPORT_TEST_SESSION = gql`
  mutation ExportTestSession($inputData: ExportTestSessionInput!) {
    exportTestSession(inputData: $inputData) {
      id
    }
  }
`
